export default function PanelGroup(props){

    return(
        <div className="panel-group">{props.label}</div>
    )
    
}